import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
//import CheckoutResultReviews from "../../components/PDP/CheckoutResultsReviews";
import data from "./data";
import PLPBanner from "./PLPBanner";
import PLPSectionWrapper from "./PLPSectionWrapper";
import PLPTicker from "./PLPTicker";
import ProductTile from "./ProductTile";
import ProductTileGrid from "./ProductTileGrid";
import { useHistory } from "react-router";
const PLP = () => {
    const { systemStarters, performanceBoosts } = data;
    const history = useHistory();
    return (_jsxs(_Fragment, { children: [_jsx(PLPBanner, {}), _jsx(PLPTicker, {}), _jsx(PLPSectionWrapper, { title: "Shop All Products", children: _jsxs(ProductTileGrid, { children: [systemStarters.map((product, i) => (_jsx(ProductTile, { href: `/app/products/${product.item_id}`, ...product }, i))), performanceBoosts.map((product, i) => (_jsx(ProductTile, { href: `/app/products/${product.item_id}`, ...product }, i)))] }) })] }));
};
export default PLP;
